import React from "react";
import InvoiceList from "./InvoiceList";
import Layout from "../Layout/Layout";
import { useState } from "react";
import ModalLayout from "../Layout/ModalLayout";
import BillingDetails from "./BillingDetails";
import { useEffect } from "react";
import { CallApiGet, CallApiPost } from "../Helper/serviceApi";
import { getUserInfo } from "../AuthUtils/AuthUtils";
import {
  exportToExcel,
  getKiplForm,
  permissionCheck,
  readLocalStorage,
  toBase64,
} from "../Helper/CommonMethods";
import { INV, INVPAY, INVS } from "../../ConfigConstants/ConfigConstants";
import FinanceSummaryList from "./FinanceSummaryList";
import moment from "moment";
import {
  DATE_FORMAT_CLIENT,
  DATE_FORMAT_SERVER,
  DATE_TIME_FORMAT_MOMENT,
  NUMBER_NINE_DECIMAL,
} from "../Helper/Constants";
import GetSvgIcon, { GetSvgUpload } from "../../images/svglist";
import ModalConfirmAlertCustom from "../Layout/ModalConfirmAlertCustom";
import { Tooltip } from "react-tooltip";
import ReactDatePicker from "react-datepicker";
import { Col, Modal, Row, Toast } from "react-bootstrap";
import Toggler from "../Utilities/Toggler";

const initSearchParam = {
  drCommYr: moment().year(),
  drCommMon: moment().month(),
  drCustType: "All",
};

const initPymtAmt = {
  availableCN: 0,
  remainingCN: 0,
  usedCN: 0,
};

const initPymtAmtAdvance = {
  availableAdvance: 0,
  remainingAdvance: 0,
  usedAdvance: 0,
};

const initErrObj = {
  newAmount: {
    value: false,
    message: "",
  },
  creditAmount: {
    value: false,
    message: "",
  },
  advanceAmount: {
    value: false,
    message: "",
  },
};

export default function InvoiceMgmMain() {
  const [spinner, setSpinner] = useState(false);
  const [pageTitle, setPageTitle] = useState();
  const [moadlConfig, setMoadlConfig] = useState(null);
  const [invoiceDataList, setInvoiceDataList] = useState([]);
  const profileId = getUserInfo("acctId");
  const accountCode = getUserInfo("accountCode");
  const customerType = getUserInfo("customerType");
  const [invoiceDetails, setInvoiceDetails] = useState({});
  const [paymentStatusBtn, setPaymentStatusBtn] = useState(true);
  const [invoiceDistributionList, setInvoiceDistributionList] = useState([]);
  const [totalaBillAmount, setTotalaBillAmount] = useState(0.0);
  const [validatePay, setValidatePay] = useState(false);
  const [customerDtls, setcustomerDtls] = useState({});
  const [searchParams, setSearchParams] = useState(initSearchParam);
  const [custTypeShow, setCustTypeShow] = useState(true);
  const [showBackBtn, setShowBackBtn] = useState(false);
  const [financeRow, setFinanceRow] = useState([]);
  const [summaryStatus, setSummaryStatus] = useState(false);
  const [unBilledInvArr, setUnBilledInvArr] = useState([]);
  const [searchBtn, setSearchBtn] = useState(true);
  const [dnCnList, setDnCNList] = useState([]);
  const [invPay, setInvPay] = useState(false);
  const [selectedCustId, setSelectedCustId] = useState();
  const [avlCreditLimit, setAvlCreditLimit] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [creditNoteApplied, setCreditNoteApplied] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [isFromBooking, setIsFromBooking] = useState(false);
  let isFrombook = false;
  const [latestInvAmt, setLatestInvAmt] = useState();
  const [cnAmt, setCnAmt] = useState();
  const [bsFileName, setBsFileName] = useState();
  const [bsFile, setBsFile] = useState({});
  const { Buffer } = require("buffer");
  let summaryCustId;
  const [applyCreditNote, setApplyCreditNote] = useState(false);
  const [inputCnAmount, setInputCnAmount] = useState(avlCreditLimit);
  const [inputInvoiceAmount, setInputInvoiceAmount] =
    useState(totalaBillAmount);
  const [cnLimit, setCnLimit] = useState(Object.assign({}, initPymtAmt));
  const [manualPayRemark, setManualPayRemark] = useState("");
  const initAlertConfig = {
    isSuccess: false,
    size: "",
    show: false,
    title: "",
    description: "",
  };
  const [alertConfig, setAlertConfig] = useState(initAlertConfig);
  const [payMoadlConfig, setPayMoadlConfig] = useState(initAlertConfig);
  const [payCnModalConfig, setPayCnModalConfig] = useState(initAlertConfig);
  const [bankSlipModalConfig, setBankSlipModalConfig] =
    useState(initAlertConfig);
  const [isRemarkBlank, setIsRemarkBlank] = useState(false);
  const [isFileBlank, setIsFileBlank] = useState(false);
  const [isCreditBalanceCalled, setIsCreditBalanceCalled] = useState(false);
  // const [errMsg,setErrMsg] = useState("")
  // const [isError,setIsError] = useState(false);
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [statusType, setStatusType] = useState("all");
  const [invDtlsData, setInvDtlsData] = useState({
    all: [],
    unpaid: [],
    inprogress: [],
    paid: [],
  });

  const [errorObj, setErrorObj] = useState(
    JSON.parse(JSON.stringify(initErrObj))
  );

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [applyAdvancePay, setApplyAdvancePay] = useState(false);
  const [avlAdvance, setAvlAdvance] = useState(
    Object.assign({}, initPymtAmtAdvance)
  );
  const [avlAdvanceLimit, setAvlAdvanceLimit] = useState(0);
  const [inputAdvanceAmount, setInputAdvanceAmount] = useState(avlAdvanceLimit);
  const [advancePaymentApplied, setAdvancePaymentApplied] = useState(false);
  const invColumns = [
    {
      name: "Trans Date",
      selector: (row) => moment(row.trans_date).format(DATE_TIME_FORMAT_MOMENT),
      sortable: true,
      filterable: true,
      // omit: hideColums,
    },
    {
      name: "Inv/Payment No",
      selector: (row) => row.ref_no,
      sortable: true,
      filterable: true,
      // omit: hideColums,
      cell: (row) => (
        <>
          <div>{row.ref_no}</div>
        </>
      ),
    },
    {
      name: "Transaction Detail",
      selector: (row) =>
        row.particulars + (!!row.mp_note ? " (" + row.mp_note + ")" : ""),
      sortable: true,
      filterable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      filterable: true,
    },
    {
      name: "Debit",
      filterable: true,
      selector: (row) => row.dr_amt,
    },
    {
      name: "Credit",
      selector: (row) => row.cr_amt,
      filterable: true,
    },
  ];

  useEffect(() => {
    if (permissionCheck(INVS, "allowedRead")?.allowedRead) {
      setPageTitle("Finance Summary");
      setPaymentStatusBtn(false);
      setCustTypeShow(true);
      setSummaryStatus(true);
      if (permissionCheck(INVPAY, "allowedWrite")?.allowedWrite) {
        setInvPay(true);
        setPaymentStatusBtn(true);
      }
      financeSummary();
      // financeSummary();
    } else if (permissionCheck(INV, "allowedRead")?.allowedRead) {
      setPaymentStatusBtn(true);
      setPageTitle("Transaction Details");
      setCustTypeShow(false);
      setSummaryStatus(false);
      fetchAllInvoiceList(profileId, "");

      // financeSummary();
    }
    setCrrentDateRange();
  }, []);

  // useEffect(() => {
  //   console.log("==error==", JSON.stringify(initErrObj));
  //   setErrorObj(JSON.parse(JSON.stringify(initErrObj)));
  // }, [payMoadlConfig]);

  const setCrrentDateRange = () => {
    if (!isFromBooking && !isFrombook) {
      setFromDate(
        moment({
          year: searchParams?.drCommYr,
          month: searchParams?.drCommMon,
          day: 1,
        })
      );
      setToDate(
        moment({
          year: searchParams?.drCommYr,
          month: searchParams?.drCommMon,
          day: 1,
        }).add(1, "M")
      );
    }
  };

  // Its call the All Invoice By the Cutomers
  const fetchAllInvoiceList = async (customerId, type) => {
    if (validateDateRange()) {
      if (!customerId) customerId = selectedCustId;
      setSpinner(true);
      // let toiDate = !!readLocalStorage("invToDate")
      //   ? readLocalStorage("invToDate")
      //   : toDate;
      // let fromiDate = !!readLocalStorage("invFromDate")
      //   ? readLocalStorage("invFromDate")
      //   : fromDate;

      let toiDate = readLocalStorage("invToDate");
      let fromiDate = readLocalStorage("invFromDate");

      // let fromDate = readLocalStorage("invFromDate");

      var param = {};
      if (type === "UBL") param.unbilled = true;
      param.customerId = customerId;

      if (!!toiDate && !!fromiDate) {
        const searchFrom = moment(fromiDate).day(1).format(DATE_FORMAT_SERVER);
        const searchTo = moment(toiDate)
          .add(1, "M")
          .day(1)
          .format(DATE_FORMAT_SERVER);
        setToDate(searchTo);
        setFromDate(searchFrom);
        setIsFromBooking(true);
        isFrombook = true;

        param.dateFrom = searchFrom;
        param.dateTo = searchTo;
      } else {
        param.dateFrom = !!fromDate
          ? moment(fromDate).format(DATE_FORMAT_SERVER)
          : moment({
              year: searchParams?.drCommYr,
              month: searchParams?.drCommMon,
              day: 1,
            }).format(DATE_FORMAT_SERVER);

        param.dateTo = !!toDate
          ? moment(toDate).format(DATE_FORMAT_SERVER)
          : moment({
              year: searchParams?.drCommYr,
              month: searchParams?.drCommMon,
              day: 1,
            })
              .add(1, "M")
              .format(DATE_FORMAT_SERVER);
      }
      setSelectedCustId(customerId);
      let invDataObj = { all: [], unpaid: [], inprogress: [], paid: [] };

      Promise.all([
        CallApiPost(`getInvoiceList`, param),
        CallApiGet("getAvlCredit?id=" + customerId, ""),
        // CallApiPost("getAllFtlOrders", payload),
        CallApiGet("getlatestInvDtls?id=" + customerId + "&type=0", ""),
        CallApiPost("getUnpaidInvoiceList", param),
      ])
        .then(([invList, avlCrd, lstInvdtl, unpdList]) => {
          setSpinner(false);
          if (invList.respCode === 200 || invList.respCode === 0) {
            if (type === "UBL") {
              setUnBilledInvArr(invList.respData);
            } else {
              setInvoiceDataList(invList.respData);
              invDataObj.all = invList.respData;

              // invDataObj.paid = invList.respData.filter(
              //   (invoice) => invoice.stat_id === 100
              // );
            }
          }
          if (unpdList.respCode === 200 || unpdList.respCode === 0) {
            invDataObj.unpaid =
              !!unpdList.respData[0]?.unpaid?.value &&
              !!JSON.parse(unpdList.respData[0].unpaid.value)[0].inv_id
                ? JSON.parse(unpdList.respData[0].unpaid.value)
                : [];
            invDataObj.inprogress =
              !!unpdList.respData[0]?.inprogress?.value &&
              !!JSON.parse(unpdList.respData[0].inprogress.value)[0].inv_id
                ? JSON.parse(unpdList.respData[0].inprogress.value)
                : [];
          }
          if (avlCrd.respCode === 200) {
            setAvlCreditLimit(-avlCrd.respData[0].payment_due);
            setCnLimit({
              availableCN: -avlCrd.respData[0].payment_due,
              remainingCN: 0,
              usedCN: -avlCrd.respData[0].payment_due,
            });
            setAvlAdvanceLimit(avlCrd.respData[0].adv_payment_amt);
            setAvlAdvance({
              availableAdvance: avlCrd.respData[0].adv_payment_amt,
              remainingAdvance: 0,
              usedAdvance: avlCrd.respData[0].adv_payment_amt,
            });
          }

          if (lstInvdtl.respCode === 200) {
            if (lstInvdtl.respData.length > 0)
              setLatestInvAmt(lstInvdtl.respData[0]?.invoice_amount);
            setCnAmt(lstInvdtl.respData[0]?.cn_amount);
          }
          setStatusType("all");
          setInvDtlsData(invDataObj);
        })
        .catch((error) => {
          console.log("Error===>", error);
          setSpinner(false);
        });

      setIsCreditBalanceCalled(true);
      // }
      financeSummary();
      localStorage.removeItem("invToDate");
      setSpinner(false);
    }
  };
  const setUpCustDtls = (custTransDtls, customerId) => {
    if (!!custTransDtls) {
      // setPaymentStatusBtn(true);
      summaryCustId = customerId;
      // setSelectedCustId(customerId)
      setcustomerDtls({
        custId: customerId,
        custName: custTransDtls.cust_name,
        custAccount: custTransDtls.acct_code,
        custOpeningBls:
          (custTransDtls.old_inv_amt ? custTransDtls.old_inv_amt : 0) -
          (custTransDtls.old_pmt_amt ? custTransDtls.old_pmt_amt : 0),
        // custOutStndBls:
        //   (custTransDtls.old_inv_amt ? custTransDtls.old_inv_amt : 0) -
        //   (custTransDtls.old_pmt_amt ? custTransDtls.old_pmt_amt : 0) +
        //   custTransDtls.inv_amt -
        //   custTransDtls.pmt_amt,
        custOutStndBls: custTransDtls.outstand_amount,
        custTotalBill: custTransDtls.inv_amt,
        custUnBill: custTransDtls.unb_amt,
        custUnPaid:
          custTransDtls.inv_amt > custTransDtls.pmt_amt
            ? custTransDtls.inv_amt - custTransDtls.pmt_amt
            : 0,
        custTotalPaid: custTransDtls?.pmt_amt,
        payAmount:
          custTransDtls.inv_amt > custTransDtls.pmt_amt
            ? custTransDtls.inv_amt - custTransDtls.pmt_amt
            : 0,
      });
    } else {
      setPaymentStatusBtn(false);
    }
  };

  const financeSummary = async () => {
    if (
      +customerType === 135 ||
      +customerType === 136 ||
      +customerType === 141 ||
      validateDateRange()
    ) {
      setSpinner(true);
      // setSummaryStatus(false);
      var param = {};
      // param.dateFrom = moment({
      //   year: searchParams?.drCommYr,
      //   month: searchParams?.drCommMon,
      //   day: 1,
      // }).format(DATE_FORMAT_SERVER);
      // param.dateTo = moment({
      //   year: searchParams?.drCommYr,
      //   month: searchParams?.drCommMon,
      //   day: 1,
      // })
      //   .add(1, "M")
      //   .format(DATE_FORMAT_SERVER);
      param.dateFrom = !!fromDate
        ? moment(fromDate).format(DATE_FORMAT_SERVER)
        : moment({
            year: searchParams?.drCommYr,
            month: searchParams?.drCommMon,
            day: 1,
          }).format(DATE_FORMAT_SERVER);

      param.dateTo = !!toDate
        ? moment(toDate).format(DATE_FORMAT_SERVER)
        : moment({
            year: searchParams?.drCommYr,
            month: searchParams?.drCommMon,
            day: 1,
          })
            .add(1, "M")
            .format(DATE_FORMAT_SERVER);
      param.customerType = searchParams?.drCustType;

      const uri = "financeSummary";
      let resp = await CallApiPost(uri, param);
      if (resp.respCode === 200) {
        setFinanceRow(resp?.respData);
        // disableBackBtn();
        let custId = !!summaryCustId ? summaryCustId : selectedCustId;
        let custDtl = !!custId
          ? resp?.respData.filter((a) => a.cust_id === +custId)[0]
          : resp?.respData[0];

        setUpCustDtls(custDtl, custDtl?.cust_id);
      }

      setSpinner(false);
    }
  };

  const setCurrentDateRange = () => {
    setFromDate(
      new Date(
        moment({
          year: searchParams?.drCommYr,
          month: searchParams?.drCommMon,
          day: 1,
        })
      )
    );

    setToDate(
      new Date(
        moment({
          year: searchParams?.drCommYr,
          month: searchParams?.drCommMon,
          day: 1,
        }).add(1, "M")
      )
    );
  };

  const setModalData = (type, data) => {
    setMoadlConfig({
      type: type,
      size: "xl",
      show: true,
      title: "Payment Details",
    });

    setInvoiceDetails(data);
  };
  const handleMoalClose = (reload = false) => {
    setMoadlConfig({
      type: "",
      size: "",
      show: false,
      title: "",
    });
  };
  const payBillNow = async () => {
    if (errorObj.newAmount.value || errorObj.creditAmount.value) {
      isDataValid();
      return;
    }
    if (!validatePayNowData().isValid) {
      return;
    }

    setSpinner(true);
    if (invoiceDistributionList.length > 0) {
      setValidatePay(false);
      let data = {
        paymentAmount: finalAmount,
        customerId: profileId,
        invoiceDistributionList,
        creditNoteApplied,
        requestCnAmount: creditNoteApplied ? handleEmptyCn(cnLimit.usedCN) : 0,
        advancePaymentApplied: applyAdvancePay,
        requestAdvPayAmount: avlAdvance.usedAdvance,
      };
      const uri = "makePayment";
      let resp = await CallApiPost(uri, data);
      if (resp.respCode === 200) {
        handleCnPayMoalClose();
        if (finalAmount > 0) {
          document.getElementById("paymentForm").innerHTML = getKiplForm(
            resp.respData,
            0
          );
          document.getElementById("onlinepayment").submit();
        } else {
          // handleCnPayMoalClose();
          window.location.reload();
        }
      } else {
        setSpinner(false);
        handleCnPayMoalClose();
        showAlert({
          isSuccess: false,
          size: "md",
          show: true,
          title: "",
          description: resp.respMessage,
        });
      }
    } else {
      setValidatePay(true);
      setTimeout(() => {
        setValidatePay(false);
      }, 5000);
    }
    setSpinner(false);
  };

  const enableBackBtn = () => {
    setShowBackBtn(true);
  };
  const disableBackBtn = () => {
    setShowBackBtn(false);
    setSearchBtn(true);
    setTotalaBillAmount(0.0);
  };

  const isDataValid = () => {
    let message = "";
    if (errorObj.newAmount.value && errorObj.creditAmount.value) {
      message = "Please correct both invoice amount and CN amount errors.";
    } else if (errorObj.newAmount.value) {
      message = "Please correct invoice amount.";
    } else if (errorObj.creditAmount.value) {
      message = "Entered CN amount should be less than Available Credit Note";
    }
    setToastMessage(message);
    setShowToast(true);
  };

  const manualPay = async () => {
    if (errorObj.newAmount.value || errorObj.creditAmount.value) {
      isDataValid();
      return;
    }

    if (!validateData().isValid) {
      return;
    }
    if (invoiceDistributionList.length > 0) {
      let remark = document.getElementById("pay-remark").value;
      setIsRemarkBlank(!remark);
      if (!remark) {
        setToastMessage("Please enter a remark before continuing.");
        setShowToast(true);
        return;
      } else {
        handlePayMoalClose();
        // setValidatePay(false);
        let data = {
          paymentAmount: (+inputInvoiceAmount).toFixed(2),
          customerId: selectedCustId,
          customerType: +customerType,
          creditNoteApplied,
          advancePaymentApplied,
          invoiceDistributionList,
          transactionRef: remark,
          requestInvAmount: parseFloat(reqInvAmt()) || 0,
          requestCnAmount: creditNoteApplied
            ? handleEmptyCn(+cnLimit.usedCN)
            : 0,
          requestAdvPayAmount: applyAdvancePay
            ? handleEmptyAdv(+avlAdvance.usedAdvance)
            : 0,
        };
        const uri = "makeManualPayment";
        let resp = await CallApiPost(uri, data);

        if (resp.respCode === 200) {
          fetchAllInvoiceList(selectedCustId, "");
          setTotalaBillAmount(0.0);
          showAlert({
            isSuccess: true,
            size: "md",
            show: true,
            title: "",
            description: resp.respData,
          });
          // window.location.reload()
        } else {
          setTotalaBillAmount(0.0);
          showAlert({
            isSuccess: false,
            size: "md",
            show: true,
            title: "",
            description: "Some Error Occured!!",
          });
        }
      }
    }
    //  else {
    //   setValidatePay(true);
    //   setTimeout(() => {
    //     setValidatePay(false);
    //   }, 5000);
    // }
    setSpinner(false);
  };

  const validateData = () => {
    let isValid = true;
    let msg = "";
    const cnUsed = creditNoteApplied ? handleEmptyCn(+cnLimit.usedCN) : 0;
    const advUsed = applyAdvancePay
      ? handleEmptyAdv(+avlAdvance.usedAdvance)
      : 0;
    const payamt = +inputInvoiceAmount || 0;
    const invAmt = +totalaBillAmount || 0;

    if (payamt >= invAmt && cnUsed > 0 && advUsed > 0) {
      msg =
        "Please enter invoice amount to be less than total bill amount if CN and Advance payment is applied.";
      isValid = false;
    } else if (
      payamt >= Math.round((invAmt + cnUsed) * 100) / 100 &&
      advUsed > 0
    ) {
      msg =
        "Please enter invoice amount to be less than total bill amount + CN amount if Advance payment is applied.";
      isValid = false;
    } else if (
      payamt >= Math.round((invAmt + advUsed) * 100) / 100 &&
      cnUsed > 0
    ) {
      msg =
        "Please enter invoice amount to be less than total bill amount + Advance payment amount if CN is applied.";
      isValid = false;
    } else if (
      payamt < invAmt &&
      invAmt < Math.round((cnUsed + advUsed + payamt) * 100) / 100
    ) {
      msg = "Total payment amount should be equal to total bill amount.";
      isValid = false;
    }

    if (creditNoteApplied && handleEmptyCn(+cnLimit.usedCN) === 0) {
      msg = "Please enter valid CN amount.";
      isValid = false;
    }

    if (
      advancePaymentApplied &&
      handleEmptyAdv(+avlAdvance.usedAdvance) === 0
    ) {
      msg = "Please enter valid Advance payment amount.";
      isValid = false;
    }

    if (!isValid) {
      setToastMessage(msg);
      setShowToast(true);
    }
    return { isValid, msg };
  };

  const validatePayNowData = () => {
    let isValid = true;
    let msg = "";

    if (creditNoteApplied && handleEmptyCn(+cnLimit.usedCN) === 0) {
      msg = "Please enter valid CN amount.";
      isValid = false;
    }

    if (!isValid) {
      setToastMessage(msg);
      setShowToast(true);
    }
    return { isValid, msg };
  };

  const reqInvAmt = () => {
    const cnUsed = creditNoteApplied ? handleEmptyCn(+cnLimit.usedCN) : 0;
    const advUsed = applyAdvancePay
      ? handleEmptyAdv(+avlAdvance.usedAdvance)
      : 0;
    const payamt = +inputInvoiceAmount || 0;

    return payamt + cnUsed + advUsed >= +totalaBillAmount
      ? +totalaBillAmount
      : payamt + cnUsed + advUsed;
  };

  const setPayModalData = (type, data) => {
    console.log(invoiceDistributionList);
    setPayMoadlConfig({
      isSuccess: false,
      size: "lg",
      show: true,
      title: "CONFIRM PAYMENT",
      description: "Are you sure you want to Pay now",
    });
    payByCreditVal(false);
    payViaAdv(false);
    setApplyCreditNote(false);
    setInputInvoiceAmount(totalaBillAmount);
    setIsRemarkBlank(false);
    setApplyAdvancePay(false);
  };

  const setCnPayModalData = (type, data) => {
    setPayCnModalConfig({
      isSuccess: false,
      size: "lg",
      show: true,
      title: "CONFIRM PAYMENT",
      description: "Are you sure you want to Pay now",
    });
    setInputInvoiceAmount(totalaBillAmount);
    setFinalAmount(totalaBillAmount);
    setApplyCreditNote(false);
  };
  const handlePayMoalClose = (reload = false) => {
    setPayMoadlConfig({
      type: "",
      size: "xl",
      show: false,
      title: "",
    });
    setManualPayRemark("");
    clearSelection();
    setErrorObj(JSON.parse(JSON.stringify(initErrObj)));
    setCnLimit({
      availableCN: avlCreditLimit,
      remainingCN: 0,
      usedCN: avlCreditLimit,
    });
    setApplyAdvancePay(false);
    setAvlAdvance({
      availableAdvance: avlAdvanceLimit,
      remainingAdvance: 0,
      usedAdvance: avlAdvanceLimit,
    });
  };

  const clearSelection = () => {
    setClearSelectedRows(!clearSelectedRows);
    setTotalaBillAmount(0);
    setInvoiceDistributionList([]);
  };

  const setBsPayModalData = (type, data) => {
    setBankSlipModalConfig({
      isSuccess: false,
      size: "md",
      show: true,
      title: "Bank Slip Upload",
      description: "Are you sure you want to Pay now",
    });
    setFinalAmount(totalaBillAmount);
  };

  const handleBsPayMoalClose = (reload = false) => {
    setBankSlipModalConfig({
      type: "",
      size: "md",
      show: false,
      title: "",
    });

    setBsFile({
      photo: "",
      photoFileName: "",
      photoFileType: "",
      photoBucketUrl: "",
    });
    clearSelection();
    setBsFileName("");
    setIsRemarkBlank(false);
    setIsFileBlank(false);
  };

  const handleCnPayMoalClose = (reload = false) => {
    setPayCnModalConfig({
      type: "",
      size: "md",
      show: false,
      title: "",
    });
    clearSelection();
    setErrorObj(JSON.parse(JSON.stringify(initErrObj)));
    setCnLimit({
      availableCN: cnLimit.availableCN,
      remainingCN: 0,
      usedCN: cnLimit.availableCN,
    });
  };

  const hideAlert = () => {
    setAlertConfig({
      isSuccess: alertConfig.isSuccess,
      size: alertConfig.size,
      show: false,
      title: "",
      description: "",
    });
  };
  const showAlert = (data) => {
    setAlertConfig({
      isSuccess: data.isSuccess,
      size: "md",
      show: true,
      title: data.title,
      description: data.description,
    });
  };

  const payByCreditVal = (checked) => {
    setCreditNoteApplied(checked);
    if (checked) {
      let amt = totalaBillAmount - avlCreditLimit;
      if (amt > 0) {
        setFinalAmount(amt.toFixed(2));
      } else setFinalAmount(0);
    } else {
      setFinalAmount(totalaBillAmount);
    }
  };
  const payViaAdv = (checked) => {
    setAdvancePaymentApplied(checked);
    if (checked) {
      let amt = totalaBillAmount - avlAdvanceLimit;
      if (amt > 0) {
        setFinalAmount(amt.toFixed(2));
      } else setFinalAmount(0);
    } else {
      setFinalAmount(totalaBillAmount);
    }
  };
  const handelChangeData = (e) => {
    if (!!e) setIsRemarkBlank(false);
  };

  const uploadBankSlip = async () => {
    if (invoiceDistributionList.length > 0) {
      let remark = document.getElementById("bs-remark").value.trim();
      let file = bsFile.photoFileName;
      setIsRemarkBlank(!remark);
      setIsFileBlank(!file);
      if (!remark || !file) {
        return;
      } else {
        setSpinner(true);
        let payload = {
          customerId: profileId,
          uploadDate: new Date(),
          remarks: document.getElementById("bs-remark").value.trim(),
          stampUser: 0,
          invoiceDistributionList,
          bankSlipModel: bsFile,
        };
        const uri = "createBankSlipUploadRequest";
        let resp = await CallApiPost(uri, payload);
        handleBsPayMoalClose();
        if (resp.respCode === 200) {
          fetchAllInvoiceList(selectedCustId, "");
          setTotalaBillAmount(0.0);
          showAlert({
            isSuccess: true,
            size: "md",
            show: true,
            title: "",
            description: "Bank Slip Uploaded Successfully",
          });
          // window.location.reload()
        } else {
          setTotalaBillAmount(0.0);
          showAlert({
            isSuccess: false,
            size: "md",
            show: true,
            title: "",
            description: resp.respData,
          });
        }
        setSpinner(false);
      }
    }
  };

  const exportData = () => {
    exportToExcel(invoiceDataList, invColumns, "invoice-list.xlsx");
  };

  const validateDateRange = () => {
    let isValid = true;
    let tdate = moment(toDate);
    let fdate = moment(fromDate);
    let dayDiff = tdate.diff(fdate, "d");
    let monthDiff = tdate.diff(fdate, "M");

    if (dayDiff > 92 || monthDiff > 3) {
      isValid = false;
      showAlert({
        isSuccess: false,
        size: "md",
        show: true,
        title: "",
        description: "The date range should not be greater than 3 months.",
      });
      setCurrentDateRange();
    }

    return isValid;
  };

  const openCustCn = (data) => {
    const encodedData = Buffer.from(
      JSON.stringify({
        custId: selectedCustId,
      })
    ).toString("base64");
    const url = `/creditNoteDtls/${encodedData}`;
    window.open(url, "_blank");
  };

  const openCustAdv = (data) => {
    const encodedData = Buffer.from(
      JSON.stringify({
        custId: selectedCustId,
      })
    ).toString("base64");
    const url = `/advDetails/${encodedData}`;
    window.open(url, "_blank");
  };

  const selectFile = async (event) => {
    const file = event.target.files;

    if (file.length === 0) {
      const newAttachment = {
        photo: "",
        photoFileName: "",
        photoFileType: "",
        photoBucketUrl: "",
      };
      setBsFile(newAttachment);
      setBsFileName("");
    } else {
      setIsFileBlank(false);
      var fileName = file[0].name;
      setBsFileName(fileName);
      var ext = fileName.substr(fileName.lastIndexOf(".") + 1);
      var photo = "";
      try {
        photo = await toBase64(file[0]);
      } catch (error) {
        console.error(error);
      }
      const newAttachment = {
        photo: photo,
        photoFileName: fileName,
        photoFileType: ext,
        photoBucketUrl: "",
      };
      setBsFile(newAttachment);
    }
  };
  const filterData = (statusType) => {
    setStatusType(statusType);
    setInvoiceDataList(invDtlsData[statusType]);
    clearSelection();
    // setPageStatus(statusType);
  };
  // code modified now
  const togglerHandler = (label, value) => {
    payByCreditVal(value);
    setApplyCreditNote(value);
    if (value) {
      setInputCnAmount("0");
      setCnLimit({
        availableCN: cnLimit.availableCN,
        remainingCN: cnLimit.availableCN,
        usedCN: 0,
      });

      // if (parseFloat(inputCnAmount) === 0) {
      //   setInputCnAmount(
      //     Math.min(avlCreditLimit, parseFloat(inputInvoiceAmount)).toString()
      //   );
      // }
      // const cnAmountToUse =
      //   parseFloat(inputCnAmount) === 0
      //     ? avlCreditLimit
      //     : parseFloat(inputCnAmount);
      // // const amt = parseFloat(inputInvoiceAmount) - cnAmountToUse;
      // // setFinalAmount(amt > 0 ? amt.toFixed(2) : 0);

      const invoice = parseFloat(inputInvoiceAmount) || 0;
      const advance = parseFloat(avlAdvance.usedAdvance) || 0;

      let final = invoice;
      if (value && applyAdvancePay) {
        final = invoice + advance;
      } else if (value) {
        final = invoice + 0;
      } else if (applyAdvancePay) {
        final = invoice + advance;
      }

      setFinalAmount(final > 0 ? final.toFixed(2) : inputInvoiceAmount);
    } else {
      // setInputCnAmount(
      //   // Math.min(avlCreditLimit, parseFloat(inputInvoiceAmount)).toString()
      //   0
      // );
      // // setFinalAmount(inputInvoiceAmount);

      setInputCnAmount("0"); // 👈 Also reset when toggled off
      const invoice = parseFloat(inputInvoiceAmount) || 0;
      const advance = parseFloat(avlAdvance.usedAdvance) || 0;
      const final = applyAdvancePay ? invoice + advance : invoice;
      setFinalAmount(final > 0 ? final.toFixed(2) : "0.00");
    }
  };

  const handleInvoiceAmountChange = (e) => {
    const newAmount = e.target.value;
    const invAmt = +totalaBillAmount || 0;
    setInputInvoiceAmount(newAmount);
    const ipInvAmt = parseFloat(newAmount) || 0;
    setFinalAmount(ipInvAmt.toFixed(2));
    const cnAmt = parseFloat(cnLimit.usedCN) || 0;
    const advAmt = parseFloat(avlAdvance.usedAdvance) || 0;
    // const cnLimit = applyCreditNote ? cnLimit
    if (applyCreditNote && applyAdvancePay) {
      const amt = ipInvAmt + (cnAmt + advAmt);
      setFinalAmount(amt > 0 ? amt.toFixed(2) : 0);
    } else if (applyCreditNote) {
      const amt = ipInvAmt + cnAmt;
      setFinalAmount(amt > 0 ? amt.toFixed(2) : 0);
    } else if (applyAdvancePay) {
      const amt = ipInvAmt + advAmt;
      setFinalAmount(amt > 0 ? amt.toFixed(2) : 0);
    } else {
      setFinalAmount(ipInvAmt.toFixed(2));
    }
    let copyErrObj = Object.assign({}, errorObj);
    if (NUMBER_NINE_DECIMAL.test(newAmount)) {
      // if (ipInvAmt > totalaBillAmount) {
      //   copyErrObj.newAmount.value = true;
      //   copyErrObj.newAmount.message =
      //     "Requested Invoice amount cannot be greater than Actual Invoice amount";
      // }
      // else {
      //   copyErrObj.newAmount.value = false;
      //   copyErrObj.newAmount.message = "";
      // }
      copyErrObj.newAmount.value = false;
      copyErrObj.newAmount.message = "";
    } else {
      copyErrObj.newAmount.value = true;
      copyErrObj.newAmount.message =
        "Please check for input data format: xxxxxxxxx.xx";
    }
    if (applyCreditNote) {
      if (+cnLimit.usedCN > invAmt) {
        copyErrObj.creditAmount.value = true;
        copyErrObj.creditAmount.message =
          "Value cannot be greater than requested invoice amount";
      } else {
        copyErrObj.creditAmount.value = false;
        copyErrObj.creditAmount.message = "";
      }
    }
    if (applyAdvancePay) {
      if (+avlAdvance.usedAdvance > invAmt) {
        copyErrObj.advanceAmount.value = true;
        copyErrObj.advanceAmount.message =
          "Value cannot be greater than requested invoice amount";
      } else {
        copyErrObj.advanceAmount.value = false;
        copyErrObj.advanceAmount.message = "";
      }
    }
    setErrorObj(Object.assign({}, copyErrObj));
  };

  const handleCnAmountChange = (e) => {
    const newCnAmount = e.target.value;
    const cnAmt = parseFloat(newCnAmount) || 0;

    const validCnAmount = Math.min(cnAmt, avlCreditLimit);
    // setInputCnAmount(validCnAmount);
    if (applyCreditNote) {
      // const amt = inputInvoiceAmount - validCnAmount;
      // setFinalAmount(amt > 0 ? amt.toFixed(2) : 0);
      const invoice = parseFloat(inputInvoiceAmount) || 0;
      const advance = parseFloat(avlAdvance.usedAdvance) || 0;

      let final = invoice;
      if (applyCreditNote && applyAdvancePay) {
        final = parseFloat(inputInvoiceAmount) + (validCnAmount + advance);
      } else if (applyCreditNote) {
        final = invoice + validCnAmount;
      } else if (applyAdvancePay) {
        final = invoice + advance;
      }

      setFinalAmount(final > 0 ? final.toFixed(2) : "0.00");
      const updateAvlCnLimit = cnLimit.availableCN - cnAmt;
      setCnLimit({
        availableCN: cnLimit.availableCN,
        remainingCN: updateAvlCnLimit,
        usedCN: e.target.value,
      });
    }
    let copyErrObj = Object.assign({}, errorObj);
    if (NUMBER_NINE_DECIMAL.test(newCnAmount)) {
      if (cnAmt > cnLimit.availableCN) {
        copyErrObj.creditAmount.value = true;
        copyErrObj.creditAmount.message =
          "Value cannot be greater than available credit limit";
      } else if (cnAmt > +totalaBillAmount) {
        copyErrObj.creditAmount.value = true;
        copyErrObj.creditAmount.message =
          "Value cannot be greater than total invoice amount";
      } else if (cnAmt === 0) {
        copyErrObj.creditAmount.value = true;
        copyErrObj.creditAmount.message = "Value cannot Zero or blank";
      } else if (cnAmt === "") {
        copyErrObj.creditAmount.value = true;
        copyErrObj.creditAmount.message = "Value cannot Blank";
      }
      // else if (
      //   applyAdvancePay === true &&
      //   validCnAmount + +avlAdvance.usedAdvance < +inputInvoiceAmount
      // ) {
      //   copyErrObj.creditAmount.value = true;
      //   copyErrObj.creditAmount.message =
      //     "Combined Value cannot be less than amount to be paid";
      // }
      // else if (
      //   applyAdvancePay === true &&
      //   validCnAmount + +avlAdvance.usedAdvance > +inputInvoiceAmount
      // ) {
      //   copyErrObj.creditAmount.value = true;
      //   copyErrObj.creditAmount.message =
      //     "Combined Value cannot be more than amount to be paid";
      // }
      else {
        copyErrObj.creditAmount.value = false;
        copyErrObj.creditAmount.message = "";
        copyErrObj.advanceAmount.value = false;
        copyErrObj.advanceAmount.message = "";
      }
    } else {
      copyErrObj.creditAmount.value = true;
      copyErrObj.creditAmount.message =
        "Please check for input data format: xxxxxxxxx.xx";
    }
    setErrorObj(Object.assign({}, copyErrObj));
  };

  const cnAmountHandleForPayNow = (e) => {
    const inputCnAmount = e.target.value;
    const newCnAmt = parseFloat(inputCnAmount) || 0;
    const validCnAmount = Math.min(newCnAmt, avlCreditLimit);
    if (applyCreditNote) {
      const invoice = parseFloat(totalaBillAmount) || 0;
      const advance = parseFloat(avlAdvance.usedAdvance) || 0;

      let final = invoice;
      if (applyCreditNote && applyAdvancePay) {
        final = parseFloat(totalaBillAmount) + (validCnAmount + advance);
      } else if (applyCreditNote) {
        final = invoice - validCnAmount;
      } else if (applyAdvancePay) {
        final = invoice - advance;
      }

      setFinalAmount(final > 0 ? final.toFixed(2) : "0.00");
      const updateAvlCnLimit = cnLimit.availableCN - newCnAmt;
      setCnLimit({
        availableCN: cnLimit.availableCN,
        remainingCN: updateAvlCnLimit,
        usedCN: e.target.value,
      });
    }
    let copyErrObj = Object.assign({}, errorObj);
    if (NUMBER_NINE_DECIMAL.test(newCnAmt)) {
      if (newCnAmt > cnLimit.availableCN) {
        copyErrObj.creditAmount.value = true;
        copyErrObj.creditAmount.message =
          "Value cannot be greater than available credit limit";
      } else if (newCnAmt > totalaBillAmount) {
        copyErrObj.creditAmount.value = true;
        copyErrObj.creditAmount.message =
          "Value cannot be greater than requested invoice amount";
      } else if (newCnAmt === 0) {
        copyErrObj.creditAmount.value = true;
        copyErrObj.creditAmount.message = "Value cannot Zero or blank";
      } else if (newCnAmt === "") {
        copyErrObj.creditAmount.value = true;
        copyErrObj.creditAmount.message = "Value cannot Blank";
      }
      // else if (
      //   applyAdvancePay === true &&
      //   validCnAmount + +avlAdvance.usedAdvance > +totalaBillAmount
      // ) {
      //   copyErrObj.creditAmount.value = true;
      //   copyErrObj.creditAmount.message =
      //     "Combined Value cannot be more than amount to be paid";
      // }
      else {
        copyErrObj.creditAmount.value = false;
        copyErrObj.creditAmount.message = "";
        copyErrObj.advanceAmount.value = false;
        copyErrObj.advanceAmount.message = "";
      }
    } else {
      copyErrObj.creditAmount.value = true;
      copyErrObj.creditAmount.message =
        "Please check for input data format: xxxxxxxxx.xx";
    }
    setErrorObj(Object.assign({}, copyErrObj));
  };

  const advAmtHandleForPayNow = (e) => {
    const newAdvAmount = e.target.value;
    const advAmt = parseFloat(newAdvAmount) || 0;
    const validAdvAmount = Math.min(advAmt, avlAdvanceLimit);
    if (applyAdvancePay) {
      const invoice = parseFloat(inputInvoiceAmount) || 0;
      const credit = parseFloat(cnLimit.usedCN) || 0;

      let final = invoice;
      if (applyCreditNote && applyAdvancePay) {
        final = parseFloat(inputInvoiceAmount) + (credit + validAdvAmount);
      } else if (applyAdvancePay) {
        final = invoice + validAdvAmount;
      } else if (applyCreditNote) {
        final = invoice + credit;
      }

      setFinalAmount(final > 0 ? final.toFixed(2) : "0.00");
      const updateAvlAdvLimit = avlAdvance.availableAdvance - advAmt;
      setAvlAdvance({
        availableAdvance: avlAdvance.availableAdvance,
        remainingAdvance: updateAvlAdvLimit,
        usedAdvance: e.target.value,
      });
    }
    let copyErrObj = Object.assign({}, errorObj);
    if (NUMBER_NINE_DECIMAL.test(newAdvAmount)) {
      if (advAmt > avlAdvance.availableAdvance) {
        copyErrObj.advanceAmount.value = true;
        copyErrObj.advanceAmount.message =
          "Value cannot be greater than available advance limit";
      } else if (advAmt > totalaBillAmount) {
        copyErrObj.advanceAmount.value = true;
        copyErrObj.advanceAmount.message =
          "Value cannot be greater than requested invoice amount";
      } else if (advAmt === 0) {
        copyErrObj.advanceAmount.value = true;
        copyErrObj.advanceAmount.message = "Value cannot Zero or blank";
      } else if (advAmt === "") {
        copyErrObj.advanceAmount.value = true;
        copyErrObj.advanceAmount.message = "Value cannot Blank";
      }
      // else if (
      //   applyCreditNote === true &&
      //   validAdvAmount + +cnLimit?.usedCN > +totalaBillAmount
      // ) {
      //   copyErrObj.advanceAmount.value = true;
      //   copyErrObj.advanceAmount.message =
      //     "Combined Value cannot be more than amount to be paid";
      // }
      else {
        copyErrObj.advanceAmount.value = false;
        copyErrObj.advanceAmount.message = "";
        copyErrObj.creditAmount.value = false;
        copyErrObj.creditAmount.message = "";
      }
    } else {
      copyErrObj.advanceAmount.value = true;
      copyErrObj.advanceAmount.message =
        "Please check for input data format: xxxxxxxxx.xx";
    }
    setErrorObj(Object.assign({}, copyErrObj));
  };

  const handleEmptyCn = (cnAmt) => {
    return cnAmt === "" ? 0 : cnAmt;
  };

  const handleEmptyAdv = (advAmt) => {
    return advAmt === "" ? 0 : advAmt;
  };

  // const validateCn = (newCnAmt) => {
  //   let copyErrObj = Object.assign({}, errorObj);
  //   if (NUMBER_NINE_DECIMAL.test(newCnAmt)) {
  //     if (newCnAmt > cnLimit.availableCN) {
  //       copyErrObj.creditAmount.value = true;
  //       copyErrObj.creditAmount.message =
  //         "Value cannot be greater than available credit limit";
  //     } else if (newCnAmt > totalaBillAmount) {
  //       copyErrObj.creditAmount.value = true;
  //       copyErrObj.creditAmount.message =
  //         "Value cannot be greater than requested invoice amount";
  //     } else if (newCnAmt === 0) {
  //       copyErrObj.creditAmount.value = true;
  //       copyErrObj.creditAmount.message = "Value cannot Zero or blank";
  //     } else if (newCnAmt === "") {
  //       copyErrObj.creditAmount.value = true;
  //       copyErrObj.creditAmount.message = "Value cannot Blank";
  //     } else {
  //       copyErrObj.creditAmount.value = false;
  //       copyErrObj.creditAmount.message = "";
  //     }
  //   } else {
  //     copyErrObj.creditAmount.value = true;
  //     copyErrObj.creditAmount.message =
  //       "Please check for input data format: xxxxxxxxx.xx";
  //   }
  //   setErrorObj(Object.assign({}, copyErrObj));
  // };

  const handleRemarkData = (e) => {
    if (!!e) setIsRemarkBlank(false);
  };

  const advancePaymentToggler = (label, value) => {
    payViaAdv(value);
    setApplyAdvancePay(value);
    if (value) {
      setInputAdvanceAmount("0");
      setAvlAdvance({
        availableAdvance: avlAdvanceLimit,
        remainingAdvance: avlAdvance.availableAdvance,
        usedAdvance: 0,
      });
      // if (parseFloat(inputAdvanceAmount) === 0) {
      //   setInputAdvanceAmount(
      //     Math.min(avlAdvanceLimit, parseFloat(inputInvoiceAmount)).toString()
      //   );
      // }
      // const advAmountToUse =
      //   parseFloat(inputAdvanceAmount) === 0
      //     ? avlAdvanceLimit
      //     : parseFloat(inputAdvanceAmount);
      // const amt = parseFloat(inputAdvanceAmount) - advAmountToUse;
      // setFinalAmount(amt > 0 ? amt.toFixed(2) : 0);
      const invoice = parseFloat(inputInvoiceAmount) || 0;
      const credit = parseFloat(cnLimit.usedCN) || 0;

      let final = invoice;
      if (applyCreditNote && value) {
        final = credit + invoice;
      } else if (value) {
        final = invoice + 0;
      } else if (applyCreditNote) {
        final = invoice + credit;
      }

      setFinalAmount(final > 0 ? final.toFixed(2) : inputInvoiceAmount);
    } else {
      // setInputCnAmount(
      //   // Math.min(avlAdvanceLimit, parseFloat(inputAdvanceAmount)).toString());
      // // setFinalAmount(inputAdvanceAmount);
      setInputAdvanceAmount("0");
      const invoice = parseFloat(inputInvoiceAmount) || 0;
      const credit = parseFloat(cnLimit.usedCN) || 0;
      const final = applyCreditNote ? invoice + credit : invoice;
      setFinalAmount(final > 0 ? final.toFixed(2) : "0.00");
    }
  };

  const handleAdvancePaymentChange = (e) => {
    const newAdvAmount = e.target.value;
    const advAmt = parseFloat(newAdvAmount) || 0;
    const validAdvAmount = Math.min(advAmt, avlAdvanceLimit);
    // setInputCnAmount(validCnAmount);
    if (applyAdvancePay) {
      const invoice = parseFloat(inputInvoiceAmount) || 0;
      const credit = parseFloat(cnLimit.usedCN) || 0;

      let final = invoice;
      if (applyCreditNote && applyAdvancePay) {
        final = parseFloat(inputInvoiceAmount) + (credit + validAdvAmount);
      } else if (applyAdvancePay) {
        final = invoice + validAdvAmount;
      } else if (applyCreditNote) {
        final = invoice + credit;
      }

      setFinalAmount(final > 0 ? final.toFixed(2) : "0.00");
      // const amt = inputAdvanceAmount - validAdvAmount;
      // setFinalAmount(amt > 0 ? amt.toFixed(2) : 0);
      const updateAvlAdvLimit = avlAdvance.availableAdvance - advAmt;
      setAvlAdvance({
        availableAdvance: avlAdvance.availableAdvance,
        remainingAdvance: updateAvlAdvLimit,
        usedAdvance: e.target.value,
      });
    }
    let copyErrObj = Object.assign({}, errorObj);
    if (NUMBER_NINE_DECIMAL.test(newAdvAmount)) {
      if (advAmt > avlAdvance.availableAdvance) {
        copyErrObj.advanceAmount.value = true;
        copyErrObj.advanceAmount.message =
          "Value cannot be greater than available advance limit";
      } else if (advAmt > +totalaBillAmount) {
        copyErrObj.advanceAmount.value = true;
        copyErrObj.advanceAmount.message =
          "Value cannot be greater than requested invoice amount";
      } else if (advAmt === 0) {
        copyErrObj.advanceAmount.value = true;
        copyErrObj.advanceAmount.message = "Value cannot Zero or blank";
      } else if (advAmt === "") {
        copyErrObj.advanceAmount.value = true;
        copyErrObj.advanceAmount.message = "Value cannot Blank";
      }
      //  else if (
      //   applyCreditNote === true &&
      //   validAdvAmount + +cnLimit?.usedCN < +inputInvoiceAmount
      // ) {
      //   copyErrObj.advanceAmount.value = true;
      //   copyErrObj.advanceAmount.message =
      //     "Combined Value cannot be less than amount to be paid";
      // }
      // else if (
      //   applyCreditNote === true &&
      //   validAdvAmount + +cnLimit?.usedCN > +inputInvoiceAmount
      // ) {
      //   copyErrObj.advanceAmount.value = true;
      //   copyErrObj.advanceAmount.message =
      //     "Combined Value cannot be more than amount to be paid";
      // }
      else {
        copyErrObj.advanceAmount.value = false;
        copyErrObj.advanceAmount.message = "";
        copyErrObj.creditAmount.value = false;
        copyErrObj.creditAmount.message = "";
      }
    } else {
      copyErrObj.advanceAmount.value = true;
      copyErrObj.advanceAmount.message =
        "Please check for input data format: xxxxxxxxx.xx";
    }
    setErrorObj(Object.assign({}, copyErrObj));
  };

  return (
    <>
      <Layout
        spinnershow={spinner}
        alertConfig={alertConfig}
        hideAlert={hideAlert}
      >
        <div className="clearfix border-bottom pb-2">
          <div className="float-start">
            <div className="section-title mt-1">{pageTitle}</div>
          </div>
          {paymentStatusBtn && !invPay ? (
            <>
              <div className="float-end">
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control fw-bold theme-blue-txt"
                    value={"" + totalaBillAmount.toFixed(2) + " RM"}
                    disabled
                  />
                  <button
                    className="theme-violet btn btn-outline-secondary"
                    type="button"
                    id="button-addon2"
                    onClick={setCnPayModalData}
                    disabled={invoiceDistributionList.length < 1}
                  >
                    Pay Now{" "}
                  </button>
                  <button
                    className="theme-violet btn btn-outline-secondary ms-1"
                    type="button"
                    id="button-addon2"
                    onClick={setBsPayModalData}
                    disabled={invoiceDistributionList.length < 1}
                  >
                    Upload Bank Slip{" "}
                  </button>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {invPay && custTypeShow && !summaryStatus ? (
            <>
              <div className="float-end">
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control fw-bold theme-blue-txt"
                    value={"" + totalaBillAmount.toFixed(2) + " RM"}
                    disabled
                  />
                  <button
                    className="theme-violet btn btn-outline-secondary"
                    type="button"
                    id="button-addon2"
                    onClick={setPayModalData}
                    disabled={invoiceDistributionList.length < 1}
                  >
                    Manual Payment{" "}
                  </button>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
        <div id="paymentForm"></div>
        {validatePay && (
          <div id="errorMsg" className="alert alert-danger mt-2" role="alert">
            Please select the invoice to pay
            <br />
          </div>
        )}

        <div className="mt-2 d-flex align-items-end justify-content-between">
          {custTypeShow && showBackBtn && (
            <>
              <div className="col-auto">
                <div className="">
                  <button
                    className="btn btn-outline-secondary theme-violet text-nowrap"
                    type="button"
                    onClick={() => {
                      disableBackBtn();
                      setSummaryStatus(true);
                    }}
                  >
                    {GetSvgIcon("BiChevronCompactLeft")}
                    Back
                  </button>
                </div>
              </div>

              <div>
                <button
                  type="button"
                  className="btn btn-outline-secondary theme-violet  mt-2 mb-2 ms-4 "
                  onClick={exportData}
                  data-tooltip-id="csv-export"
                  disabled={invoiceDataList.length === 0 ? true : false}
                >
                  {GetSvgIcon("SpreadSheet")}
                </button>
                <Tooltip
                  id="csv-export"
                  content="Download to Excel"
                  place="top"
                  style={{ zIndex: "100" }}
                />
              </div>
            </>
          )}
        </div>

        <div className="d-flex align-item-center justify-content-start py-3 m-1 ">
          {/* {searchBtn && ( */}
          <div className="col-auto">
            <div className="border rounded p-2 me-3 wt-tbl float-start">
              <div className="d-flex align-item-center">
                <div className="col-auto align-self-center d-flex">
                  <label
                    htmlFor=""
                    className="form-label theme-label align-self-center me-2"
                    title="This field is mandatory"
                  >
                    From Date:
                  </label>
                  <ReactDatePicker
                    placeholderText="Select Trip Date"
                    className="form-control"
                    dateFormat={DATE_FORMAT_CLIENT}
                    selected={!!fromDate ? new Date(fromDate) : fromDate}
                    onFocus={(e) => e.target.blur()}
                    onChange={(d) => setFromDate(d)}
                    onSelect={(d) => setFromDate(d)}
                    maxDate={new Date(toDate)}
                    // minDate={new Date(moment(toDate).subtract(3,"months"))}
                  />
                </div>
                <div className="col-auto align-self-center d-flex">
                  <label
                    htmlFor=""
                    className="form-label theme-label ms-3 align-self-center"
                    title="This field is mandatory"
                  >
                    To Date:
                  </label>
                  <ReactDatePicker
                    placeholderText="Select Trip Date"
                    className="form-control "
                    dateFormat={DATE_FORMAT_CLIENT}
                    selected={!!toDate ? new Date(toDate) : toDate}
                    onFocus={(e) => e.target.blur()}
                    onChange={(d) => setToDate(d)}
                    onSelect={(d) => setToDate(d)}
                    // maxDate={new Date()}
                    minDate={new Date(fromDate)}
                  />
                </div>
              </div>
            </div>
            <button
              type="button"
              className="btn btn-outline-secondary theme-violet text-nowrap float-end mt-2"
              // onClick={() => loadDataBySbuAndTripDate()}

              // disabled={!(!!fromDate && !!toDate)}
              onClick={() => {
                if (summaryStatus) financeSummary();
                // financeSummary();
                if (!summaryStatus) fetchAllInvoiceList();
              }}
            >
              {GetSvgIcon("Search")}
            </button>
          </div>
          {/* )} */}
          {[135, 136, 141].includes(+customerType) && (
            <div>
              <button
                type="button"
                className="btn btn-outline-secondary theme-violet  mt-2 mb-2 ms-4 "
                onClick={exportData}
                data-tooltip-id="csv-export"
                disabled={invoiceDataList.length === 0 ? true : false}
              >
                {GetSvgIcon("SpreadSheet")}
              </button>
              <Tooltip
                id="csv-export"
                content="Download to Excel"
                place="top"
                style={{ zIndex: "100" }}
              />
            </div>
          )}
        </div>

        {
          // paymentStatusBtn
          summaryStatus ? (
            <FinanceSummaryList
              setPaymentStatusBtn={setPaymentStatusBtn}
              paymentStatusBtn={paymentStatusBtn}
              setModalData={setModalData}
              setInvoiceDistributionList={setInvoiceDistributionList}
              invoiceDistributionList={invoiceDistributionList}
              setTotalaBillAmount={setTotalaBillAmount}
              customerDtls={customerDtls}
              setSearchParams={setSearchParams}
              searchParams={searchParams}
              custTypeShow={custTypeShow}
              financeRow={financeRow}
              summaryStatus={summaryStatus}
              setSummaryStatus={setSummaryStatus}
              setcustomerDtls={setcustomerDtls}
              enableBackBtn={enableBackBtn}
              fetchAllInvoiceList={fetchAllInvoiceList}
              invoiceSummaryList={invoiceDataList}
              unBilledInvArr={unBilledInvArr}
              setUpCustDtls={setUpCustDtls}
              setSearchBtn={setSearchBtn}
              setSpinner={setSpinner}
            />
          ) : (
            <InvoiceList
              invoiceDataList={invoiceDataList}
              setModalData={setModalData}
              paymentStatusBtn={paymentStatusBtn}
              setInvoiceDistributionList={setInvoiceDistributionList}
              setTotalaBillAmount={setTotalaBillAmount}
              customerDtls={customerDtls}
              fetchAllInvoiceList={fetchAllInvoiceList}
              unBilledInvArr={unBilledInvArr}
              dnCnList={dnCnList}
              setSpinner={setSpinner}
              invColumns={invColumns}
              latestInvAmt={latestInvAmt}
              cnAmt={cnAmt}
              openCustCn={openCustCn}
              avlCreditLimit={avlCreditLimit}
              clearSelectedRows={clearSelectedRows}
              statusType={statusType}
              filterData={filterData}
              avlAdvanceLimit={avlAdvanceLimit}
              openCustAdv={openCustAdv}
            />
          )
        }
      </Layout>
      {!!moadlConfig && (
        <ModalLayout
          moadlConfig={moadlConfig}
          handleMoalClose={handleMoalClose}
        >
          <BillingDetails
            setModalData={setModalData}
            invoiceDetails={invoiceDetails}
          />
        </ModalLayout>
      )}
      {/* /*This modal is used for manula Payment */}
      <ManualPaymentCustomModal
        confirmAlertConfig={payMoadlConfig}
        hideConfirmAlert={handlePayMoalClose}
        confirmAlert={manualPay}
        cancelBtnName={"Cancel"}
        confirmBtnName={"Paid"}
        modalStyle={{ titelStyle: "theme-label fs-3 " }}
        // disableConfirm={
        //   errorObj?.newAmount?.value || errorObj?.creditAmount?.value
        // }
      >
        <>
          <div className="row">
            <div className="col-md-6  text-start">
              <label
                htmlFor="floatingInputGrid"
                className="form-label theme-label"
              >
                Invoice Amount :
              </label>
            </div>
            <div className="col-md-6 mb-2 text-start">
              <label className="form-label ">
                <b>{totalaBillAmount.toFixed(2)} RM</b>
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6  text-start">
              <label
                htmlFor="floatingInputGrid"
                className="form-label theme-label mt-2"
              >
                Amount Paid :<span className="text-danger">&#9733;</span>
              </label>
            </div>
            <div className="col-md-6 mb-3 text-start">
              <input
                className="form-control"
                type="text"
                inputMode="numeric"
                maxLength={12}
                value={inputInvoiceAmount}
                onChange={handleInvoiceAmountChange}
                // disabled={true}
              />
              {!!errorObj?.newAmount?.value && errorObj?.newAmount?.value && (
                <div>
                  <span className="text-danger fw-bold font-12">
                    &#9888; {errorObj?.newAmount?.message}
                  </span>
                </div>
              )}
            </div>
          </div>
          <Row className="mt-2">
            {/* CREDIT NOTE CARD */}
            {cnLimit?.availableCN > 0 && (
              <Col md={avlAdvanceLimit > 0 ? 6 : 12} className="px-2">
                <div className="card text-bg-light mb-3">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-12 mb-2 text-start d-flex align-items-center">
                        <Toggler
                          btnName="btn_from"
                          isBtn1Checked={applyCreditNote === true}
                          isBtn2Checked={applyCreditNote === false}
                          btn1Value={true}
                          btn2Value={false}
                          btn1Label="YES"
                          btn2Label="NO"
                          handler={togglerHandler}
                        />
                        <span className="ms-2">Apply Credit Note</span>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <>
                      <div className="row">
                        <div className="col-md-12 text-start">
                          <label className="form-label theme-label">
                            Available Credit Note:
                          </label>
                        </div>
                        <div className="col-md-6 mb-1 text-start">
                          <label className="form-label">
                            <b>{cnLimit?.availableCN?.toFixed(2)} RM</b>
                          </label>
                        </div>
                        <div className="col-md-2"></div>
                      </div>

                      {applyCreditNote && (
                        <>
                          <div className="row">
                            <div className="col-md-12 text-start">
                              <label className="form-label theme-label">
                                Remaining Credit Note:
                              </label>
                            </div>
                            <div className="col-md-6 mb-1 text-start">
                              <label className="form-label">
                                <b>{cnLimit?.remainingCN?.toFixed(2)} RM</b>
                              </label>
                            </div>
                            <div className="col-md-2"></div>
                          </div>

                          <div className="row">
                            <div className="col-md-12 mt-1 text-start pe-0">
                              <label className="form-label theme-label">
                                Enter CN amount to adjust against invoice:
                              </label>
                            </div>
                            <div className="col-md text-start">
                              <input
                                className="form-control"
                                type="text"
                                value={cnLimit?.usedCN}
                                onChange={handleCnAmountChange}
                              />
                              {!!errorObj?.creditAmount?.value && (
                                <div>
                                  <span className="text-danger fw-bold font-12">
                                    &#9888; {errorObj?.creditAmount?.message}
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className="col-md-2"></div>
                          </div>
                        </>
                      )}
                    </>
                  </div>
                </div>
              </Col>
            )}

            {/* ADVANCE PAYMENT CARD */}
            {avlAdvanceLimit > 0 && (
              <Col className="px-2">
                <div className="card text-bg-light mb-3">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-12 mb-2 text-start d-flex align-items-center">
                        <Toggler
                          btnName="btn_from1"
                          isBtn1Checked={applyAdvancePay === true}
                          isBtn2Checked={applyAdvancePay === false}
                          btn1Value={true}
                          btn2Value={false}
                          btn1Label="YES"
                          btn2Label="NO"
                          handler={advancePaymentToggler}
                        />
                        <span className="ms-2">Apply Advance Payment</span>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12 text-start">
                        <label className="form-label theme-label">
                          Available Advance Payment:
                        </label>
                      </div>
                      <div className="col-md-6 mb-1 text-start">
                        <label className="form-label">
                          <b>{avlAdvanceLimit?.toFixed(2)} RM</b>
                        </label>
                      </div>
                      <div className="col-md-2"></div>
                    </div>

                    {applyAdvancePay && (
                      <>
                        <div className="row">
                          <div className="col-md-12 text-start">
                            <label className="form-label theme-label">
                              Remaining Advance Payment:
                            </label>
                          </div>
                          <div className="col-md-6 mb-1 text-start">
                            <label className="form-label">
                              <b>
                                {avlAdvance?.remainingAdvance?.toFixed(2)} RM
                              </b>
                            </label>
                          </div>
                          <div className="col-md-2"></div>
                        </div>

                        <div className="row">
                          <div className="col-md-12 mt-1 text-start pe-0">
                            <label className="form-label theme-label">
                              Enter Advance amount to adjust invoice:
                            </label>
                          </div>
                          <div className="col-md text-start">
                            <input
                              className="form-control"
                              type="text"
                              value={avlAdvance?.usedAdvance}
                              onChange={handleAdvancePaymentChange}
                            />
                            {!!errorObj?.advanceAmount?.value && (
                              <div>
                                <span className="text-danger fw-bold font-12">
                                  &#9888; {errorObj?.advanceAmount?.message}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="col-md-2"></div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Col>
            )}
          </Row>

          <hr></hr>
          <div className="row">
            <div className="col-md-6 text-start">
              <label
                htmlFor="floatingInputGrid"
                className="form-label theme-label"
              >
                Final Amount :
              </label>
            </div>
            <div className="col-md-6 mb-2 text-start ">
              <label className="form-label">
                <b>{(+finalAmount).toFixed(2)} RM</b>
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <label
                htmlFor="floatingInputGrid"
                className="form-label theme-label"
              >
                Remark <span className="text-danger">&#9733;</span>
              </label>
            </div>
            <div className="col-md-9 mb-2">
              <textarea
                className="form-control"
                id="pay-remark"
                rows={4}
                onChange={(e) => handleRemarkData(e.target.value)}
              ></textarea>
              {/* {isRemarkBlank && (
                <div style={{ textAlign: "left" }}>
                  <span className="badge bg-danger">
                    &#9888; This field is required.
                  </span>
                </div>
              )} */}
            </div>
          </div>
        </>
      </ManualPaymentCustomModal>

      {/* credit adjustment payment */}
      <ManualPaymentCustomModal
        confirmAlertConfig={payCnModalConfig}
        hideConfirmAlert={handleCnPayMoalClose}
        confirmAlert={payBillNow}
        cancelBtnName={"Cancel"}
        confirmBtnName={"PayNow"}
        // disableConfirm={errorObj?.creditAmount?.value}
      >
        <>
          <div className="row">
            <div className="col-md-6  text-start">
              <label
                htmlFor="floatingInputGrid"
                className="form-label theme-label fs-5"
              >
                Amount :
              </label>
            </div>
            <div className="col-md-6 mb-2 text-start">
              <label className="form-label fs-4">
                <b>{totalaBillAmount.toFixed(2)} RM</b>
              </label>
            </div>
          </div>

          <Row className="mt-2">
            {/* CREDIT NOTE CARD */}
            <Col md={avlAdvanceLimit > 0 ? 6 : 12} className="px-2">
              <div className="card text-bg-light mb-3">
                <div className="card-header">
                  <div className="row">
                    <div className="col-md-12 mb-2 text-start d-flex align-items-center">
                      <Toggler
                        btnName="btn_from"
                        isBtn1Checked={applyCreditNote === true}
                        isBtn2Checked={applyCreditNote === false}
                        btn1Value={true}
                        btn2Value={false}
                        btn1Label="YES"
                        btn2Label="NO"
                        handler={togglerHandler}
                      />
                      <span className="ms-2">Apply Credit Note</span>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {cnLimit?.availableCN > 0 && (
                    <>
                      <div className="row">
                        <div className="col-md-12 text-start">
                          <label className="form-label theme-label">
                            Available Credit Note:
                          </label>
                        </div>
                        <div className="col-md-6 mb-1 text-start">
                          <label className="form-label">
                            <b>{cnLimit?.availableCN?.toFixed(2)} RM</b>
                          </label>
                        </div>
                        <div className="col-md-2"></div>
                      </div>

                      {applyCreditNote && (
                        <>
                          <div className="row">
                            <div className="col-md-12 text-start">
                              <label className="form-label theme-label">
                                Remaining Credit Note:
                              </label>
                            </div>
                            <div className="col-md-6 mb-1 text-start">
                              <label className="form-label">
                                <b>{cnLimit?.remainingCN?.toFixed(2)} RM</b>
                              </label>
                            </div>
                            <div className="col-md-2"></div>
                          </div>

                          <div className="row">
                            <div className="col-md-12 mt-1 text-start pe-0">
                              <label className="form-label theme-label">
                                Enter CN amount to adjust against invoice:
                              </label>
                            </div>
                            <div className="col-md text-start">
                              <input
                                className="form-control"
                                type="text"
                                value={cnLimit?.usedCN}
                                onChange={cnAmountHandleForPayNow}
                              />
                              {!!errorObj?.creditAmount?.value && (
                                <div>
                                  <span className="text-danger fw-bold font-12">
                                    &#9888; {errorObj?.creditAmount?.message}
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className="col-md-2"></div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Col>

            {/* ADVANCE PAYMENT CARD */}
            {avlAdvanceLimit > 0 && (
              <Col className="px-2">
                <div className="card text-bg-light mb-3">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-12 mb-2 text-start d-flex align-items-center">
                        <Toggler
                          btnName="btn_from1"
                          isBtn1Checked={applyAdvancePay === true}
                          isBtn2Checked={applyAdvancePay === false}
                          btn1Value={true}
                          btn2Value={false}
                          btn1Label="YES"
                          btn2Label="NO"
                          handler={advancePaymentToggler}
                        />
                        <span className="ms-2">Apply Advance Payment</span>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12 text-start">
                        <label className="form-label theme-label">
                          Available Advance Payment:
                        </label>
                      </div>
                      <div className="col-md-6 mb-1 text-start">
                        <label className="form-label">
                          <b>{avlAdvanceLimit?.toFixed(2)} RM</b>
                        </label>
                      </div>
                      <div className="col-md-2"></div>
                    </div>

                    {applyAdvancePay && (
                      <>
                        <div className="row">
                          <div className="col-md-12 text-start">
                            <label className="form-label theme-label">
                              Remaining Advance Payment:
                            </label>
                          </div>
                          <div className="col-md-6 mb-1 text-start">
                            <label className="form-label">
                              <b>
                                {avlAdvance?.remainingAdvance?.toFixed(2)} RM
                              </b>
                            </label>
                          </div>
                          <div className="col-md-2"></div>
                        </div>

                        <div className="row">
                          <div className="col-md-12 mt-1 text-start pe-0">
                            <label className="form-label theme-label">
                              Enter Advance amount to adjust invoice:
                            </label>
                          </div>
                          <div className="col-md text-start">
                            <input
                              className="form-control"
                              type="text"
                              value={avlAdvance?.usedAdvance}
                              onChange={advAmtHandleForPayNow}
                            />
                            {!!errorObj?.advanceAmount?.value && (
                              <div>
                                <span className="text-danger fw-bold font-12">
                                  &#9888; {errorObj?.advanceAmount?.message}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="col-md-2"></div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Col>
            )}
          </Row>
          <hr></hr>
          <div className="row">
            <div className="col-md-6 text-start">
              <label
                htmlFor="floatingInputGrid"
                className="form-label theme-label fs-5"
              >
                Final Amount :
              </label>
            </div>
            <div className="col-md-6 mb-2 text-start ">
              <label className="form-label fs-4">
                <b>{(+finalAmount).toFixed(2)} RM</b>
              </label>
            </div>
          </div>
        </>
      </ManualPaymentCustomModal>

      {/* /*This modal is used for Bank slip upload */}
      <ModalConfirmAlertCustom
        confirmAlertConfig={bankSlipModalConfig}
        hideConfirmAlert={handleBsPayMoalClose}
        confirmAlert={uploadBankSlip}
        cancelBtnName={"Cancel"}
        confirmBtnName={"Upload"}
        modalStyle={{ titelStyle: "theme-label fs-3 " }}
      >
        <>
          <div className="row">
            <div className="col-md-3  text-start">
              <label
                htmlFor="floatingInputGrid"
                className="form-label theme-label"
              >
                Bank Slip<span className="text-danger">&#9733;</span>
              </label>
            </div>
            <div className="col mb-2 text-start">
              <div className="Upload-Photo w-100 mb-2">
                <input
                  type="file"
                  accept="application/pdf, image/jpeg, image/jpg"
                  id="vhclImgR"
                  onChange={(e) => selectFile(e)}
                />
                <div className="uploaded-text ms-2">
                  {GetSvgUpload({ required: false })}
                  {bsFileName}
                </div>
              </div>
              {isFileBlank && (
                <div style={{ textAlign: "left" }}>
                  <span className="badge bg-danger">
                    &#9888; This field is required.
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <label
                htmlFor="floatingInputGrid"
                className="form-label theme-label"
              >
                Remark <span className="text-danger">&#9733;</span>
              </label>
            </div>
            <div className="col-md-9 mb-2">
              <textarea
                className="form-control"
                id="bs-remark"
                rows={4}
                onChange={(e) => handelChangeData(e.target.value)}
              ></textarea>

              {isRemarkBlank && (
                <div style={{ textAlign: "left" }}>
                  <span className="badge bg-danger">
                    &#9888; This field is required.
                  </span>
                </div>
              )}
            </div>
          </div>
        </>
      </ModalConfirmAlertCustom>
      <div
        style={{
          position: "fixed",
          top: 20,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 9999,
        }}
      >
        <Toast
          style={{
            backgroundColor: "white",
            opacity: 1,
            border: "1px solid #dee2e6",
          }}
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={5000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Error</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </div>
    </>
  );
}
// Manual Payment Modal
const ManualPaymentCustomModal = ({
  children,
  confirmAlertConfig,
  hideConfirmAlert,
  confirmAlert,
  confirmBtnName,
  cancelBtnName,
  modalStyle,
  disableConfirm,
}) => {
  return (
    <>
      <Modal
        size={confirmAlertConfig.size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={confirmAlertConfig.show}
        onHide={hideConfirmAlert}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className={modalStyle?.titelStyle}>
            {confirmAlertConfig.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-center">{children}</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-danger me-2"
            onClick={hideConfirmAlert}
          >
            {cancelBtnName}
          </button>
          <button
            type="button"
            className="btn btn-primary theme-violet"
            onClick={confirmAlert}
            disabled={disableConfirm}
          >
            {confirmBtnName}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
